import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { routeTo } from 'redux-router-kit';

import * as DeveloperActions from 'app/developer-v3/Actions';
import * as CliApp from 'app/entities/CliApp';
import * as CliAppDefinition from 'app/entities/CliAppDefinition';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import PreloadPage from 'app/developer-v3/components/PreloadPage';
import { getAppUrl } from 'app/developer-v3/utils';
import hocify from 'app/common/components/hocify';
import {
  currentAppDefinitionEntity,
  currentAppVersionEntities,
  currentDefinitionOverride,
} from 'app/developer-v3/selectors';
import { selectAppId } from 'app/developer-v3/store/selectors';

import InsightsPage from './InsightsPage';

const mapStateToProps = state => {
  const appId = String(selectAppId(state));
  const app = CliApp.selectors.all.entity(appId, state);
  const serviceId = CliApp.selectors.serviceId(app);
  const isPublished = CliApp.selectors.isPublished(app);

  const isLoading = CliApp.selectors.all.isLoadingById(appId, state);
  const definition = currentDefinitionOverride(state);
  const appDefinitionEntity = currentAppDefinitionEntity(state);
  const isGUIIntegration =
    !isLoading &&
    CliAppDefinition.selectors.isGUIIntegration(appDefinitionEntity);

  return {
    appId,
    serviceId,
    isPublished,
    hasActions:
      !isGUIIntegration ||
      !isEmpty(definition.creates) ||
      !isEmpty(definition.searches),
    hasTriggers: !isGUIIntegration || !isEmpty(definition.triggers),
    isLoading,
    versions: currentAppVersionEntities(state).map(version =>
      CliAppDefinition.selectors.version(version)
    ),
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  onLoad() {
    const { id, version } = props.params;
    dispatch(DeveloperActions.loadAppAndVersion(id, version));
  },
  async redirectToHome() {
    setTimeout(() => dispatch(routeTo(`${getAppUrl(props.params.id)}`)), 0);
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  hocify(LoadingBlockOrComponent, { LoadingComponent: PreloadPage })(
    InsightsPage
  )
);
